import {forwardRef, useImperativeHandle, useRef, useCallback, useEffect, useState} from 'react';

export default forwardRef((props, ref) => {
  const [filterState, setFilterState] = useState('');
  const textInput = useRef();

  useImperativeHandle(ref, () => {
    return {
      isFilterActive() {
        return filterState;
      },
      doesFilterPass(params) {
        const filterLowerCase = filterState.toLowerCase();
        const field = props.colDef.field;
        const value = params.data[field] ? params.data[field].toString().toLowerCase() : '';
        return value.indexOf(filterLowerCase) >= 0;
      },
      getModel() {
        if (!filterState) return undefined;
        return {
          state: filterState,
        };
      },
      setModel(model) {
        if (!model) {
          setFilterState('');
        } else {
          setFilterState(model.state);
        }
      },
      setValue(value) {
        setFilterState(value);
      },
      afterGuiAttached() {
        textInput.current && textInput.current.focus();
      },
    };
  });

  useEffect(() => {
    props.filterChangedCallback();
  }, [filterState]);

  const clearFilter = (e) => {
    textInput.current.value = '';
    offListener();
  };

  const onFilterChange = (e) => {
    setFilterState(e.target.value);
  };

  const offListener = useCallback(() => setFilterState(''), []);

  return (
    <div className="padding-2">
      <label className="usa-label margin-top-0">Filter by name</label>
      <input
        type="text"
        placeholder="Type here"
        className="usa-input"
        ref={textInput}
        onChange={onFilterChange}
        value={filterState}
      />
      <button className="margin-y-1 float-right usa-button usa-button--outline" onClick={clearFilter}>
        Clear
      </button>
    </div>
  );
});
